
import DirectNotification from "../../../assets/duotone/DirectNotification.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DirectNotificationIcon({ className, dataTestid = "DirectNotificationIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <DirectNotification data-testid={dataTestid} className={classes} {...rest} />
  );
}
